import { createApi } from '@reduxjs/toolkit/query/react';

import { AUTH_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const authApi = createApi({
    baseQuery: getBaseQuery(AUTH_API_URL),
    reducerPath: 'authApi',
    endpoints: (build) => ({
        getCompassUserNameMap: build.query({
            query: () => 'profile/compass/name_map',
            transformResponse: (response) => response,
            transformErrorResponse: handleRTKQueryError('An error occurred retrieving user names.'),
        }),
    }),
});

export const { useGetCompassUserNameMapQuery } = authApi;
